export const LAST_AUTH_PROVIDER_STORAGE_KEY = "lastAuthProvider";
export const PREFERRED_FIAT_PROVIDER_STORAGE_KEY = "preferredFiatProvider";
export async function setLastAuthProvider(authProvider, storage) {
    await storage.setItem(LAST_AUTH_PROVIDER_STORAGE_KEY, authProvider);
}
export async function getLastAuthProvider(storage) {
    return (await storage.getItem(LAST_AUTH_PROVIDER_STORAGE_KEY));
}
//# sourceMappingURL=storage.js.map